import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import { Breadcrumb, BreadcrumbItem } from "reactstrap";
import { config } from "../config";
import { crumbsTrail } from "../States/Meetings";
import { underscoreToSpacedCamel } from "./Text";

export function get_landing_page() {
  // this function can be used for custom redirect logic
  return config.landing_page;
}


export const Breadcrumbs = ({ children }) => {
  const no_show_list = [
    '/meetings/live/', '/workspace/meetings/lite/'
  ];
  let crumbs = crumbsTrail.get();
  let current_location = window.location.href.replace(window.location.origin, "");
  let current_location_in_crumb = -1;
  let parent_location = current_location.split("/").slice(0, -1).join("/");
  let parent_location_in_crumb = -1;

  crumbs.map((crumb, index) => {
    if(crumb.includes(current_location) && current_location_in_crumb === -1) {
      current_location_in_crumb = index;
    }
    if(crumb.includes(parent_location) && parent_location_in_crumb === -1) {
      parent_location_in_crumb = index;
    }
  });

  let is_no_show = false;
  no_show_list.forEach(element => {
    if(current_location.includes(element)) {
      is_no_show = true;
    }
  });
  if(is_no_show) {
    return <></>;
  }

  if(current_location === config.landing_page) {
    crumbs = [];
  } else if(parent_location_in_crumb !== -1) {
    crumbs = crumbs.splice(0, parent_location_in_crumb);
    crumbs.push(current_location);
  } else if(current_location_in_crumb === 0) {
    crumbs = [current_location];
  } else if(current_location_in_crumb !== -1) {
    crumbs = crumbs.splice(0, current_location_in_crumb + 1);
  } else {
    crumbs.push(current_location);
  }

  crumbsTrail.set(crumbs);
  return <Fragment>
    <Breadcrumb>
      {children}
      <BreadcrumbItem key={"home"}><Link to={config.landing_page}>Home</Link></BreadcrumbItem>
      {crumbs.map((crumb, index) => {
        let splice_index = -1;
        let name = crumb.split("/").slice(splice_index)[0];
        if(name.length === 36) {
          splice_index = splice_index - 1;
          name = crumb.split("/").slice(splice_index)[0];
        }
        let regExp = /[a-zA-Z]/g;
        while(!regExp.test(name)){
          splice_index = splice_index - 1;
          name = crumb.split("/").slice(splice_index)[0];
        }
        return <BreadcrumbItem key={crumb}><Link to={crumb}>{underscoreToSpacedCamel(name.split("?")[0])}</Link></BreadcrumbItem>
      })}
    </Breadcrumb>
  </Fragment>;
}